import * as React from 'react';

interface StickyFooterViewProps {
  ButtonsDiv?: JSX.Element;
}

export default class StickyFooterView extends React.Component<StickyFooterViewProps> {
  render() {
    //for temp fix for workspace view, add style={{ left:'300px'}}
    return (
      <div className="sticky-footer">
        <div className="sticky-footer-buttons-container">{this.props.ButtonsDiv}</div>
      </div>
    );
  }
}
